window.addEventListener('DOMContentLoaded', () => {
    animateNumbers();
});

function animateNumbers() {
    const uspNumbers = document.getElementsByClassName("uspBlock__usps-item-title");
    const uspBlockUsps = document.getElementById("uspBlock__usps");

    if (uspBlockUsps && uspNumbers) {
        const start = 0;
        const duration = 1000;
        let intervalIds = [];

        const animateNumber = (element) => {
            let current = start;
            let end = +element.innerHTML;
            const increment = (end / duration) * 10;
            const intervalId = setInterval(() => {
                current += increment;
                if (current >= end) {
                    clearInterval(intervalId);
                    current = end;
                }
                element.innerHTML = Math.round(current);
            }, 10);
            intervalIds.push(intervalId);
        };

        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                document.querySelectorAll(".uspBlock__usps-item-title").forEach((element) => {
                    if (Number.isInteger(+element.innerHTML)) {
                        animateNumber(element);
                    }
                });
                observer.unobserve(entries[0].target);
            }
        });

        observer.observe(document.querySelector(".uspBlock__usps-item-title"));

        setTimeout(() => {
            intervalIds.forEach((intervalId) => {
                clearInterval(intervalId);
            });
        }, 10000);
    }
}